import script from "./StaticTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./StaticTooltip.vue?vue&type=script&setup=true&lang=js"

import "./StaticTooltip.vue?vue&type=style&index=0&id=6decd03b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6decd03b"]])

export default __exports__